<template>
  <v-app id="inspire">
    <v-navigation-drawer
      color="blue darken-4"
      v-model="drawer"
      app
      :mini-variant="mini"
      width="250"
      mini-variant-width="84"
      mobile-break-point="900"
      :clipped="true"
    >
      <v-list class="pt-5 overflow-y-auto" dense nav dark style="height: 100%;">
        <template v-for="(item, i) in routes">
          <!------------------------------------------------->
          <!-- SIMPLE ITEM ---------------------------------->
          <!------------------------------------------------->
          <template v-if="!item.items">
            <v-list-item v-if="item.show" :key="i" :to="item.to">
              <v-list-item-icon>
                <v-icon v-if="item.icon">
                  {{ item.icon }}
                </v-icon>
                <v-img
                  v-else
                  :src="require(`${item.img}.png`)"
                  aspect-ratio="1"
                  max-width="20"
                  contain
                />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.pointer">
                <v-icon color="grey lighten-1" small>
                  fiber_manual_record
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
          <!------------------------------------------------->
          <!-- GROUP ITEMS ---------------------------------->
          <!------------------------------------------------->
          <template v-else>
            <v-list-group
              v-if="item.show"
              :key="i"
              no-action
              active-class="white--text"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon v-if="item.icon">
                    {{ item.icon }}
                  </v-icon>
                  <v-img
                    v-else
                    :src="require(`${item.img}.png`)"
                    aspect-ratio="1"
                    max-width="20"
                    contain
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template v-for="(subitem, j) in item.items">
                <v-list-item
                  v-if="subitem.show"
                  :key="j"
                  :to="subitem.to"
                  active-class="white--text"
                >
                  <v-list-item-title>{{ subitem.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="white" :clipped-left="true" app class="pr-0">
      <v-app-bar-nav-icon
        color="primary"
        class="ml-1"
        @click.stop="mini = !mini"
      ></v-app-bar-nav-icon>
      <v-divider vertical class="mx-4"></v-divider>
      <v-toolbar-title>
        <span class="hidden-sm-and-down">
          <img
            src="@/assets/afrus_logo_2.png"
            class="afrus-drawer-logo"
            alt="afrus"
          />
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text @click="openBull">
          <v-icon>layers</v-icon>
          {{ $t('general.queues') }}
        </v-btn>
        <v-menu
          transition="slide-y-transition"
          offset-y
          right
          nudge-bottom="10"
          style="z-index: 100;"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              <div class="afrus-profile-user">
                <strong>
                  {{ `${user.person.first_name} ${user.person.last_name}` }}
                </strong>
              </div>
              <v-avatar color="#02579b" size="40" class="ml-4">
                <span class="white--text subheading">
                  {{
                    `${user.person.first_name[0]}${user.person.last_name[0]}`
                  }}
                </span>
              </v-avatar>
            </v-btn>
          </template>
          <v-card min-width="250">
            <v-list v-if="user" dense>
              <v-list-item>
                <v-list-item-avatar size="40" color="primary" class="mr-4">
                  <span class="subheading white--text">
                    {{
                      `${user.person.first_name[0]}${user.person.last_name[0]}`
                    }}
                  </span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-uppercase">
                    {{ `${user.person.first_name} ${user.person.last_name}` }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider />
            <v-list>
              <v-list-item to="/account/profile">
                <v-list-item-icon class="ml-2 mr-5 my-3">
                  <v-icon color="primary">
                    person_outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="ml-1">
                  {{ $t('general.profile') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout()">
                <v-list-item-icon class="ml-2 mr-5 my-3">
                  <v-icon color="primary">
                    exit_to_app
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="ml-1">
                  {{ $t('general.logout') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-container v-else class="pa-8">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import permissionMixin from '@/mixins/permission'

export default {
  mixins: [permissionMixin],
  async created () {
    // this.isLoading = true
    // await this.getProfile()
    // this.isLoading = false
  },
  data () {
    return {
      isLoading: false,
      dialog: false,
      drawer: null,
      mini: false
    }
  },
  methods: {
    ...mapActions({
      getProfile: 'auth/getProfile'
    }),
    ...mapMutations({
      resetLanguaje: 'auth/resetLanguaje'
    }),
    logout () {
      this.$auth.destroyToken()
      this.resetLanguaje()
      this.$router.push({ name: 'login' })
    },
    openBull () {
      window.open('https://queues.afrus.app/', '_blank')
    }
  },
  computed: {
    ...mapState({
      user: ({ auth: { user } }) => user
    }),
    routes () {
      const { can } = this
      return [
        {
          icon: 'home',
          text: 'Dashboard',
          to: '/dashboard',
          show: can('dashboard-view')
        },
        {
          icon: 'payments',
          text: this.$t('transactions.title'),
          to: '/transactions',
          show: can('dashboard-view')
        },
        {
          icon: 'inbox',
          text: 'Inbox',
          to: '/inbox',
          show: can('dashboard-view')
        },
        {
          icon: 'business',
          text: this.$t('organization.title'),
          show: true,
          items: [
            {
              text: 'Index',
              to: '/orgs/index',
              show: true
            },
            { text: 'Reportes', to: '/orgs/reports', show: true },
            { text: 'Pricing Models', to: '/orgs/pricing-models', show: true },
            {
              text: 'Servicio de facturación',
              to: '/orgs/billing-service',
              show: true
            },
            {
              text: 'Informe de facturación',
              to: '/orgs/billing-resume',
              show: true
            }
          ]
        },
        {
          icon: 'assignment_ind',
          text: 'Signup',
          show: true,
          items: [
            {
              text: 'Stakeholders',
              to: '/signup/stakeholders',
              show: true
            },
            {
              text: 'Logs',
              to: '/signup/logs',
              show: true
            },
            {
              text: 'syncLeads',
              to: '/signup/syncLeads',
              show: true
            }
          ]
        },
        {
          icon: 'assignment_ind',
          text: 'Merge Tags',
          to: '/merge-tags',
          show: true
        },
        {
          icon: 'sports_score',
          text: 'Objetivos',
          show: true,
          to: '/goals'
        },
        {
          icon: 'settings',
          text: 'Tipos de identificación',
          show: true,
          to: '/identification-types'
        },
        {
          icon: 'view_list',
          text: this.$t('dashboard_clients.title'),
          show: true,
          items: [
            {
              text: this.$t('dashboard_clients.organizations.title'),
              to: '/dashboard-clients/index',
              show: true
            },
            {
              text: this.$t('dashboard_clients.global_stats'),
              to: '/dashboard-clients/stats',
              show: true
            },
            {
              text: this.$t('dashboard_clients.metrics'),
              to: '/dashboard-clients/clients-stats',
              show: true
            }
          ]
        },
        {
          icon: 'event_repeat',
          text: this.$t('subscriptions.title'),
          to: '/subscriptions',
          show: true
        },
        {
          icon: 'people',
          text: this.$t('users.title'),
          to: '/users',
          show: true
        },
        {
          icon: 'verified_user',
          text: 'Roles y permisos',
          show: true,
          items: [
            {
              text: this.$tc('roles.title', 2),
              to: '/roles-permissions/roles',
              show: true
            },
            {
              text: this.$tc('permissions.title', 2),
              to: '/roles-permissions/permissions',
              show: true
            },
            {
              text: this.$tc('actionsModel.title', 2),
              to: '/roles-permissions/actions',
              show: true
            },
            {
              text: this.$tc('sections.title', 2),
              to: '/roles-permissions/sections',
              show: true
            }
          ]
        },
        {
          icon: 'settings',
          text: this.$t('settings.title'),
          to: '/terms',
          show: true
        },
        {
          icon: 'arrow_downward',
          text: this.$t('downloads.title'),
          to: '/downloads',
          show: true
        },
        {
          icon: 'dns',
          text: this.$t('domains.title'),
          to: '/domains',
          show: true
        },
        {
          icon: 'extension',
          text: 'Facturación',
          show: true,
          items: [
            {
              text: 'Facturación transacciones',
              to: '/addons/billing',
              show: true
            },
            {
              text: 'Facturación Automation',
              to: '/addons/billing-automation',
              show: true
            },
            {
              text: 'Administrar costos',
              to: '/addons/manage-costs',
              show: true
            }
          ]
        },
        {
          icon: 'inbox',
          text: this.$t('tableLogger.title'),
          to: '/admin-logs',
          show: true
        },
        {
          icon: 'web',
          text: this.$t('templates.title'),
          show: true,
          items: [
            { text: 'Gallery', to: '/templates/gallery', show: true },
            { text: 'Layouts', to: '/templates/layouts', show: true }
          ]
        },
        {
          icon: 'email',
          text: 'Email ' + this.$t('communications.metrics.path'),
          show: true,
          to: '/email-metrics',
        },
        {
          icon: 'notifications',
          text: 'Comunications',
          show: true,
          items: [
            { text: 'General', to: '/comunications', show: true },
            {
              text: this.$t('notifications.title'),
              to: '/comunications/notifications',
              show: true
            },
            {
              text: 'By organization',
              to: '/comunications/organization',
              show: true
            },
            {
              text: this.$t('notifications.title'),
              to: '/comunications/notifications',
              show: true
            },
            {
              text: 'By organization',
              to: '/comunications/organization',
              show: true
            },
            {
              text: 'New release timer',
              to: '/comunications/release-timer',
              show: true
            },
            {
              text: 'New Release PopUp',
              to: '/comunications/popup',
              show: true
            },
            {
              text: 'Terminos, Condiciones y Politicas de privacidad',
              to: '/comunications/terms-privacy',
              show: true
            }
          ]
        },
        {
          icon: 'auto_awesome_motion',
          text: 'Onboarding',
          show: true,
          items: [
            {
              text: 'AWS',
              to: '/onboarding/aws',
              show: true
            },
            { text: 'Articles', to: '/onboarding/articles', show: true }
          ]
        },
        {
          icon: 'people',
          text: 'Afrus Engine',
          show: true,
          items: [
            { text: 'Logs', to: '/afrus-engine/logs', show: true },
            {
              text: 'Suscripciones',
              to: '/afrus-engine/subscriptions',
              show: true
            },
            {
              text: 'Estadistica de Suscripciones',
              to: '/afrus-engine/stats',
              show: true
            },
            {
              text: this.$t('subscriptions_report.title'),
              to: '/afrus-engine/subscriptions-report',
              show: true
            }
          ]
        },
        {
          icon: 'settings_accessibility',
          text: 'Triggers',
          show: true,
          to: '/triggers'
        },
        {
          icon: 'rebase_edit',
          text: 'ETLS',
          show: true,
          to: '/etls'
        },
        {
          icon: 'mark_email_read',
          text: 'Email Validation',
          show: true,
          to: '/email-validation'
        }
      ]
    }
  }
}
</script>
